var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/macros/date-macro.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
var macro_t_1 = runtime.makeMacro(
[], 
["value", "dayCount"], 
function (kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("value", kwargs.hasOwnProperty("value") ? kwargs["value"] : runtime.contextOrFrameLookup(context, frame, "None"));
frame.set("dayCount", kwargs.hasOwnProperty("dayCount") ? kwargs["dayCount"] : 31);
var t_2 = "";var t_3;
t_3 = runtime.contextOrFrameLookup(context, frame, "dayCount") + 1;
frame.set("dayCountMaxRange", t_3, true);
if(frame.topLevel) {
context.setVariable("dayCountMaxRange", t_3);
}
if(frame.topLevel) {
context.addExport("dayCountMaxRange", t_3);
}
frame = frame.push();
var t_6 = (lineno = 9, colno = 19, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "range"), "range", context, [1,runtime.contextOrFrameLookup(context, frame, "dayCountMaxRange")]));
if(t_6) {var t_5 = t_6.length;
for(var t_4=0; t_4 < t_6.length; t_4++) {
var t_7 = t_6[t_4];
frame.set("i", t_7);
frame.set("loop.index", t_4 + 1);
frame.set("loop.index0", t_4);
frame.set("loop.revindex", t_5 - t_4);
frame.set("loop.revindex0", t_5 - t_4 - 1);
frame.set("loop.first", t_4 === 0);
frame.set("loop.last", t_4 === t_5 - 1);
frame.set("loop.length", t_5);
t_2 += "<option value=\"";
t_2 += runtime.suppressValue(t_7, env.opts.autoescape);
t_2 += "\" ";
if(runtime.contextOrFrameLookup(context, frame, "value") == t_7) {
t_2 += " selected ";
;
}
t_2 += ">";
t_2 += runtime.suppressValue(t_7, env.opts.autoescape);
t_2 += "</option>";
;
}
}
frame = frame.pop();
;
frame = frame.pop();
return new runtime.SafeString(t_2);
});
context.addExport("dayOptions");
context.setVariable("dayOptions", macro_t_1);
var macro_t_8 = runtime.makeMacro(
[], 
["value"], 
function (kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("value", kwargs.hasOwnProperty("value") ? kwargs["value"] : runtime.contextOrFrameLookup(context, frame, "None"));
var t_9 = "";t_9 += "<option value=\"01\" ";
if(runtime.contextOrFrameLookup(context, frame, "value") == "01") {
t_9 += " selected ";
;
}
t_9 += ">\n        ";
t_9 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"localizations")),"containers")),"chromeLocalization")),"account_month_values_january"), env.opts.autoescape);
t_9 += "\n    </option>\n    <option value=\"02\" ";
if(runtime.contextOrFrameLookup(context, frame, "value") == "02") {
t_9 += " selected ";
;
}
t_9 += ">\n        ";
t_9 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"localizations")),"containers")),"chromeLocalization")),"account_month_values_february"), env.opts.autoescape);
t_9 += "\n    </option>\n    <option value=\"03\" ";
if(runtime.contextOrFrameLookup(context, frame, "value") == "03") {
t_9 += " selected ";
;
}
t_9 += ">\n        ";
t_9 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"localizations")),"containers")),"chromeLocalization")),"account_month_values_march"), env.opts.autoescape);
t_9 += "\n    </option>\n    <option value=\"04\" ";
if(runtime.contextOrFrameLookup(context, frame, "value") == "04") {
t_9 += " selected ";
;
}
t_9 += ">\n        ";
t_9 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"localizations")),"containers")),"chromeLocalization")),"account_month_values_april"), env.opts.autoescape);
t_9 += "\n    </option>\n    <option value=\"05\" ";
if(runtime.contextOrFrameLookup(context, frame, "value") == "05") {
t_9 += " selected ";
;
}
t_9 += ">\n        ";
t_9 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"localizations")),"containers")),"chromeLocalization")),"account_month_values_may"), env.opts.autoescape);
t_9 += "\n    </option>\n    <option value=\"06\" ";
if(runtime.contextOrFrameLookup(context, frame, "value") == "06") {
t_9 += " selected ";
;
}
t_9 += ">\n        ";
t_9 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"localizations")),"containers")),"chromeLocalization")),"account_month_values_june"), env.opts.autoescape);
t_9 += "\n    </option>\n    <option value=\"07\" ";
if(runtime.contextOrFrameLookup(context, frame, "value") == "07") {
t_9 += " selected ";
;
}
t_9 += ">\n        ";
t_9 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"localizations")),"containers")),"chromeLocalization")),"account_month_values_july"), env.opts.autoescape);
t_9 += "\n    </option>\n    <option value=\"08\" ";
if(runtime.contextOrFrameLookup(context, frame, "value") == "08") {
t_9 += " selected ";
;
}
t_9 += ">\n        ";
t_9 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"localizations")),"containers")),"chromeLocalization")),"account_month_values_august"), env.opts.autoescape);
t_9 += "\n    </option>\n    <option value=\"09\" ";
if(runtime.contextOrFrameLookup(context, frame, "value") == "09") {
t_9 += " selected ";
;
}
t_9 += ">\n        ";
t_9 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"localizations")),"containers")),"chromeLocalization")),"account_month_values_september"), env.opts.autoescape);
t_9 += "\n    </option>\n    <option value=\"10\" ";
if(runtime.contextOrFrameLookup(context, frame, "value") == "10") {
t_9 += " selected ";
;
}
t_9 += ">\n        ";
t_9 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"localizations")),"containers")),"chromeLocalization")),"account_month_values_october"), env.opts.autoescape);
t_9 += "\n    </option>\n    <option value=\"11\" ";
if(runtime.contextOrFrameLookup(context, frame, "value") == "11") {
t_9 += " selected ";
;
}
t_9 += ">\n        ";
t_9 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"localizations")),"containers")),"chromeLocalization")),"account_month_values_november"), env.opts.autoescape);
t_9 += "\n    </option>\n    <option value=\"12\" ";
if(runtime.contextOrFrameLookup(context, frame, "value") == "12") {
t_9 += " selected ";
;
}
t_9 += ">\n        ";
t_9 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"localizations")),"containers")),"chromeLocalization")),"account_month_values_december"), env.opts.autoescape);
t_9 += "\n    </option>";
;
frame = frame.pop();
return new runtime.SafeString(t_9);
});
context.addExport("monthOptions");
context.setVariable("monthOptions", macro_t_8);
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/macros/date-macro.j2"] , dependencies)